<template>
  <BaseModal :id="`ModalRemoveInstructor-${instructorId}`" :size="'md'" title="Remove assessor">
    <div class="text-dark py-2">Are you sure you want to remove this assessor?</div>

    <b-alert show class="my-1" variant="danger">
      <div ref="instructor-name">
        {{ instructorName }}
      </div>
    </b-alert>

    <div class="text-dark py-2">Click at the “Remove” button to remove this assessor.</div>

    <template slot="modal-footer">
      <b-button variant="link" class="btn-link-dark" @click="hide()"> Cancel </b-button>

      <b-button ref="button-remove-instructor" variant="danger" @click="removeInstructor">
        <span v-if="!isLoading">Remove</span>
        <span v-else class="pr-2 pl-2">
          <b-spinner label="Loading..." variant="secondary" small />
        </span>
      </b-button>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/base-components/BaseModal';
import LearningUnitMember from '@/models/LearningUnitMember';

export default {
  name: 'ModalRemoveInstructor',

  components: { BaseModal },

  props: {
    instructorName: {
      type: String,
      default: ''
    },

    instructorId: {
      type: Number,
      default: null
    },

    instructorUserId: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    async removeInstructor() {
      this.isLoading = true;

      try {
        await LearningUnitMember.api().removeMemberAssessor(this.instructorId);

        this.$emit('removeMember', true);

        this.$toast.success('The assessor was removed successfully');
      } catch (error) {
        this.$toast.error('Cannot remove assessor, please try again');
      }

      this.isLoading = false;

      this.hide();
    },

    reset() {
      this.email = '';
      this.instructor = null;
      this.isNotFound = false;
    },

    show() {
      this.$bvModal.show(`ModalRemoveInstructor-${this.instructorId}`);
    },
    hide() {
      this.$bvModal.hide(`ModalRemoveInstructor-${this.instructorId}`);
    },

    closeModal() {},

    openModal() {
      console.log('Open modal1');
    }
  }
};
</script>

<style lang="scss" scoped></style>
